// Logic shared by the apply and edit membership views (identical in both).
import axios from "axios";
import storageService from "@/services/storage.service";

const DOC_FILE_KEYS = {
  nat_identity: "selectedFile1",
  driver: "selectedFile2",
  passport: "selectedFile3",
  utility: "selectedFile4",
  birth_cert: "selectedFile5",
};
const MAX_PAY_SLIP_BYTES = 4 * 1024 * 1024;

export default {
  data() {
    return {
      // documents already saved on the server: { slot: { name }, pay_slip: [{ id, name }] }
      existingDocs: { pay_slip: [] },
      docBusy: false,
    };
  },
  computed: {
    combinedValue() {
      return this.selectedCountryCode
        ? `+${this.selectedCountryCode} ${this.phoneNumber}`
        : this.phoneNumber;
    },
    validationError() {
      return !/^\+\d+\s\d+$/.test(this.combinedValue);
    },
    isSSNRequired() {
      return (
        this.form.personal6.citizenRadio === "True" ||
        this.form.personal6.citizenRadio === ""
      );
    },
    // --------------------------------------------------------------
    isIssueDateInvalid() {
      if (!this.form.personal1.nidIssueDate || !this.form.personal1.nidExpiry) {
        return false; // Don't show the error message if any date is empty
      }
      return (
        new Date(this.form.personal1.nidIssueDate) >=
        new Date(this.form.personal1.nidExpiry)
      );
    },
    isExpiryDateInvalid() {
      if (!this.form.personal1.nidIssueDate || !this.form.personal1.nidExpiry) {
        return false; // Don't show the error message if any date is empty
      }
      return (
        new Date(this.form.personal1.nidExpiry) <=
        new Date(this.form.personal1.nidIssueDate)
      );
    },
    isIssueDateFuture() {
      if (!this.form.personal1.nidIssueDate) {
        return false; // Don't show the error message if the Issue Date is empty
      }
      return new Date(this.form.personal1.nidIssueDate) > new Date();
    },
    // -------------------------------------------------------------
    isdidIssueDateInvalid() {
      if (!this.form.personal1.didIssueDate || !this.form.personal1.didExpiry) {
        return false; // Don't show the error message if any date is empty
      }
      return (
        new Date(this.form.personal1.didIssueDate) >=
        new Date(this.form.personal1.didExpiry)
      );
    },
    isdidExpiryDateInvalid() {
      if (!this.form.personal1.didIssueDate || !this.form.personal1.didExpiry) {
        return false; // Don't show the error message if any date is empty
      }
      return (
        new Date(this.form.personal1.didExpiry) <=
        new Date(this.form.personal1.didIssueDate)
      );
    },
    isdidIssueDateFuture() {
      if (!this.form.personal1.didIssueDate) {
        return false; // Don't show the error message if the Issue Date is empty
      }
      return new Date(this.form.personal1.didIssueDate) > new Date();
    },
    ispassIssueDateInvalid() {
      if (
        !this.form.personal1.passIssueDate ||
        !this.form.personal1.passExpiry
      ) {
        return false; // Don't show the error message if any date is empty
      }
      return (
        new Date(this.form.personal1.passIssueDate) >=
        new Date(this.form.personal1.passExpiry)
      );
    },

    ispassExpiryDateInvalid() {
      if (
        !this.form.personal1.passIssueDate ||
        !this.form.personal1.passExpiry
      ) {
        return false; // Don't show the error message if any date is empty
      }
      return (
        new Date(this.form.personal1.passExpiry) <=
        new Date(this.form.personal1.passIssueDate)
      );
    },
    ispassIssueDateFuture() {
      if (!this.form.personal1.passIssueDate) {
        return false; // Don't show the error message if the Issue Date is empty
      }
      return new Date(this.form.personal1.passIssueDate) > new Date();
    },
  },

  watch: {
    value(newValue) {
      this.selectedCountryCode = this.extractCountryCode(newValue);
      this.phoneNumber = this.extractPhoneNumber(newValue);
    },
    "form.personal1.dob": function (newDOB) {
      if (newDOB && new Date(newDOB) > new Date()) {
        this.isInvalidDOB = true;
        // Clear the "Date of Birth" if it's invalid
        this.form.personal1.dob = "";
        // Set a timer to hide the error message after 2 seconds
        setTimeout(() => {
          this.isInvalidDOB = false;
        }, 2000);
      }


      if (newDOB) {
        const currentDate = new Date();
        const inputDate = new Date(newDOB);
        const ageDiffMilliseconds = currentDate - inputDate;
        const ageDate = new Date(ageDiffMilliseconds);
        const age = Math.abs(ageDate.getUTCFullYear() - 1970);
        if (this.radioSelected1 === "minor" && age >= 18) {
          // If 'minor' is selected but the entered age is 18 or older
          this.invalidDOBMinor = true;
          this.form.personal1.dob = "";
          setTimeout(() => {
            this.invalidDOBMinor = false;
          }, 2000);
        } else if (this.radioSelected1 === "adult" && age < 18) {
          // If 'adult' is selected but the entered age is less than 18
          this.invalidDOBadult = true;
          this.form.personal1.dob = "";
          setTimeout(() => {
            this.invalidDOBadult = false; // Fix: Set to false after timeout, not true
          }, 2000);
        } else {
          // Clear any previous invalid DOB messages
        }
      } else {
        // Clear any previous invalid DOB messages if no DOB is entered
      }
    },

    "form.personal8.appointnominee_dob1": function (newDOB) {
      if (newDOB && new Date(newDOB) > new Date()) {
        this.isInvalidDOB1 = true;
        // Clear the "Date of Birth" if it's invalid
        this.form.personal8.appointnominee_dob1 = "";
        // Set a timer to hide the error message after 2 seconds
        setTimeout(() => {
          this.isInvalidDOB1 = false;
        }, 2000);
      }
    },
    "form.personal8.appointnominee_dob2": function (newDOB) {
      if (newDOB && new Date(newDOB) > new Date()) {
        this.isInvalidDOB2 = true;
        // Clear the "Date of Birth" if it's invalid
        this.form.personal8.appointnominee_dob2 = "";
        // Set a timer to hide the error message after 2 seconds
        setTimeout(() => {
          this.isInvalidDOB2 = false;
        }, 2000);
      }
    },
    "form.personal8.appointnominee_dob3": function (newDOB) {
      if (newDOB && new Date(newDOB) > new Date()) {
        this.isInvalidDOB3 = true;
        // Clear the "Date of Birth" if it's invalid
        this.form.personal8.appointnominee_dob3 = "";
        // Set a timer to hide the error message after 2 seconds
        setTimeout(() => {
          this.isInvalidDOB3 = false;
        }, 2000);
      }
    },
    "form.personal1.nidIssueDate": function (newIssueDate) {
      if (newIssueDate && this.form.personal1.nidExpiry) {
        if (new Date(newIssueDate) >= new Date(this.form.personal1.nidExpiry)) {
          this.showMessageAfterClearingExpiry = true;
        } else {
          this.showMessageAfterClearingExpiry = false;
        }
      }
    },
    "form.personal1.nidExpiry": function (newExpiryDate) {
      if (newExpiryDate && this.form.personal1.nidIssueDate) {
        if (
          new Date(newExpiryDate) <= new Date(this.form.personal1.nidIssueDate)
        ) {
          this.showMessageAfterClearingExpiry = true;
        } else {
          this.showMessageAfterClearingExpiry = false;
        }
      }
    },
    "form.personal1.didIssueDate": function (newIssueDate) {
      if (newIssueDate && this.form.personal1.didExpiry) {
        if (new Date(newIssueDate) >= new Date(this.form.personal1.didExpiry)) {
          this.showMessageAfterClearingdid = true;
          setTimeout(() => {
            this.showMessageAfterClearingdid = false;
          }, 2000);
        } else {
          this.showMessageAfterClearingdid = false;
        }
      }
    },
    "form.personal1.didExpiry": function (newExpiryDate) {
      if (newExpiryDate && this.form.personal1.didIssueDate) {
        if (
          new Date(newExpiryDate) <= new Date(this.form.personal1.didIssueDate)
        ) {
          this.showMessageAfterClearing = true;
        } else {
          this.showMessageAfterClearing = false;
        }
      }
    },
  },

  methods: {
    extractCountryCode(value) {
      const match = value.match(/^\+(\d+)\s/);
      return match ? match[1] : "";
    },
    extractPhoneNumber(value) {
      const match = value.match(/^\+\d+\s(.*)/);
      return match ? match[1] : "";
    },
    validatePhoneNumber() {
      this.phoneNumber = this.phoneNumber.replace(/\D/g, "");
    },
    updateParentValue() {
      const newValue = this.combinedValue;
      this.$emit("input", newValue);
    },
    validateZipCode() {
      if (this.form.personal1.zip_code !== null) {
        this.form.personal1.zip_code = this.form.personal1.zip_code
          .toString()
          .slice(0, 5);
      }
    },
    validatenumbrtrans() {
      if (this.form.personal3.numTrans !== null) {
        this.form.personal3.numTrans = this.form.personal3.numTrans
          .toString()
          .slice(0, 11);
      }
    },
    validatevlumtrans() {
      if (this.form.personal3.volTrans !== null) {
        this.form.personal3.volTrans = this.form.personal3.volTrans
          .toString()
          .slice(0, 11);
      }
    },
    validateSSNNO() {
      if (this.form.personal6.ssn_no !== null) {
        this.form.personal6.ssn_no = this.form.personal6.ssn_no
          .toString()
          .slice(0, 11);
      }
    },
    validatenationalidentification() {
      if (this.form.personal1.nationalIdNum !== null) {
        this.form.personal1.nationalIdNum = this.form.personal1.nationalIdNum
          .toString()
          .slice(0, 11);
        this.errorpart = true;
        setTimeout(() => {
          this.errorpart = false;
        }, 10000);
      } else {
        this.errorpart = false;
      }
    },
    validatepassportnumber() {
      if (this.form.personal1.passportNum !== null) {
        this.form.personal1.passportNum = this.form.personal1.passportNum
          .toString()
          .slice(0, 10);
      }
    },
    isValidationError() {
      // Check if at least one of the three sections is filled
      const nationalIdNumFilled = !!this.form.personal1.nationalIdNum;
      const drivingIdNumFilled = !!this.form.personal1.drivingIdNum;
      const passportNumFilled = !!this.form.personal1.passportNum;

      if (!nationalIdNumFilled && !drivingIdNumFilled && !passportNumFilled) {
        this.errorpartone = true;
        this.errorparttwo = false;

        setTimeout(() => {
          this.errorpartone = false;
        }, 5000);

        return false;
      } else {
        this.errorpartone = false;
        return true;
      }
    },
    isDriverPermitValidationError() {
      // Check if Driver’s Permit No. is filled, and at least one more field is filled
      const drivingIdNumFilled = !!this.form.personal1.drivingIdNum;
      const nationalIdNumFilled = !!this.form.personal1.nationalIdNum;
      const passportNumFilled = !!this.form.personal1.passportNum;

      if (drivingIdNumFilled && !nationalIdNumFilled && !passportNumFilled) {
        this.errorparttwo = true;
        this.errorpartone = false;

        setTimeout(() => {
          this.errorparttwo = false;
        }, 5000);
        return false;
      } else {
        this.errorparttwo = false;
        return true;
      }
    },
    threeFieldcheck() {
      const isFormInvalid = this.isValidationError();
      const isFormInvalid1 = this.isDriverPermitValidationError();
      if (isFormInvalid && isFormInvalid1) {
        return true;
      } else {
        return false;
      }
    },
    onFileChange1(event) {
      this.selectedFile1 = event.target.files[0];
    },
    onFileChange2(event) {
      this.selectedFile2 = event.target.files[0];
    },
    onFileChange3(event) {
      this.selectedFile3 = event.target.files[0];
    },
    onFileChange4(event) {
      this.selectedFile4 = event.target.files[0];
    },
    onFileChange5(event) {
      this.selectedFile5 = event.target.files[0];
    },
    onFileChange6(event) {
      this.selectedFile6 = event.target.files[0];
    },
    onFileChange7(event) {
      this.selectedFile7 = event.target.files[0];
    },
    onFileChange8(event) {
      this.selectedFile8 = event.target.files[0];
    },
    onFileChange9(event) {
      const files = Array.from(event.target.files || []);
      if (files.some((file) => file.size > MAX_PAY_SLIP_BYTES)) {
        this.fileSizeError9 = "Each file must be less than 4MB.";
      } else {
        this.fileSizeError9 = "";
        this.selectedFile9 = [...(this.selectedFile9 || []), ...files];
      }
      event.target.value = ""; // the chosen files are listed below the input
    },
    // ---- saved data: fill every field from the server so a refresh never loses it
    applyServerData(app) {
      if (!app) return;
      const blank = (v) =>
        v === null || v === undefined || v === "undefined" || v === "null" || v === "";
      // only overwrite a field when the server has a value (keeps the form defaults)
      const put = (target, key, value) => {
        if (!blank(value)) target[key] = value;
      };
      const bool = (v) => (v === true || v === "True" || v === "true" ? "True" : "False");
      const putBool = (target, key, value) => {
        if (value !== null && value !== undefined) target[key] = bool(value);
      };

      const a1 = app.section_a1;
      if (a1) {
        const f = this.form.personal1;
        put(f, "branchName", a1.branch);
        put(f, "title", a1.applicant_title);
        put(f, "firstName", a1.first_name);
        put(f, "middleName", a1.middle_name);
        put(f, "surname", a1.sur_name);
        put(f, "address", a1.home_address);
        put(f, "address_line", a1.address_line);
        put(f, "address_line_two", a1.address_line_two);
        put(f, "city_name", a1.city_name);
        put(f, "state_name", a1.state_name);
        put(f, "zip_code", a1.zip_code);
        put(f, "country_name", a1.country_name);
        put(f, "dob", a1.dob);
        put(f, "gender", a1.gender);
        put(f, "numOfDependents", a1.dependents);
        put(f, "placeOfdob", a1.place_of_birth);
        put(f, "nationality", a1.nationality);
        put(f, "maritalStatus", a1.marital);
        const nat = a1.nat_identity || {};
        put(f, "nationalIdNum", nat.number);
        put(f, "nidIssueDate", nat.issue_on);
        put(f, "nidExpiry", nat.expire_on);
        put(f, "nationalIssuance", nat.isuue_country);
        const drv = a1.driver || {};
        put(f, "drivingIdNum", drv.number);
        put(f, "didIssueDate", drv.issue_on);
        put(f, "didExpiry", drv.expire_on);
        put(f, "driverIssuance", drv.isuue_country);
        const pass = a1.passport || {};
        put(f, "passportNum", pass.number);
        put(f, "passIssueDate", pass.issue_on);
        put(f, "passExpiry", pass.expire_on);
        put(f, "passportIssuance", pass.isuue_country);
        const birth = a1.birth_cert || {};
        put(f, "birthIdNum", birth.number);
        put(f, "birthIssuance", birth.isuue_country);
        put(f, "homePhoneNum", a1.home_contact);
        put(f, "homePhoneNumcode", a1.ext_home_contact);
        put(f, "mobileNum", a1.mob_contact);
        put(f, "mobileNumcode", a1.ext_mob_contact);
        put(f, "email", a1.email);
      }

      const b2 = app.section_b2;
      if (b2) {
        const f = this.form.personal2;
        put(f, "employStatus", b2.emp_status);
        put(f, "frequencyStatus", b2.pay_freq);
        const period = String(b2.emp_time || "")
          .split(" ")
          .filter((part) => !blank(part));
        put(f, "user_howlong", period[0]);
        put(f, "user_howlong2", period[1]);
        put(f, "averageIncm", b2.avg_mnth_income);
        put(f, "user_occupation", b2.occupation);
        put(f, "employer", b2.employer);
        put(f, "user_employer", b2.emp_address);
        put(f, "user_w_phone_no", b2.work_contact);
        put(f, "user_w_phone_nocode", b2.ext_work_contact);
        put(f, "user_phone_no", b2.extra_ext_work);
        put(f, "user_isstudent", b2.school);
      }

      const c3 = app.section_c3;
      if (c3) {
        const f = this.form.personal3;
        put(f, "accFunded", c3.fund_source);
        if (!blank(c3.mem_in_others)) {
          f.accountActi = String(c3.mem_in_others).toLowerCase() === "true";
        }
        put(f, "accountActiDesc", c3.mem_in_others_desc);
        put(f, "other_details", c3.others_details);
        put(f, "socuceofincome", c3.socuce_of_income);
        put(f, "areaofdetails", c3.area_of_details);
        put(f, "numTrans", c3.nos_trx);
        put(f, "volTrans", c3.vol_trx);
      }

      const d4 = app.section_d4;
      if (d4) {
        const f = this.form.personal4;
        put(f, "parentName", d4.incare_g && d4.incare_g.name);
        put(f, "parentId", d4.incare_g && d4.incare_g.identification);
        put(f, "trusteeName", d4.incare_t && d4.incare_t.name);
        put(f, "trusteeId", d4.incare_t && d4.incare_t.identification);
        put(f, "advisor", d4.advisor);
        if (d4.decleration !== null && d4.decleration !== undefined) {
          f.declaration = d4.decleration;
        }
        this.form.personal9.nameofparent = f.parentName;
        this.form.personal9.nameoftrustee = f.trusteeName;
      }

      const e5 = app.section_e5;
      if (e5) {
        const f = this.form.personal5;
        putBool(f, "entrustedRadio", e5.prom_entrust);
        putBool(f, "memberOfRadio", e5.immd_famly);
        putBool(f, "referredRadio", e5.close_prsonl);
      }

      const f6 = app.section_f6;
      if (f6) {
        const f = this.form.personal6;
        putBool(f, "tobagoRadio", f6.other_citizen);
        putBool(f, "citizenRadio", f6.us_citizen);
        put(f, "ssn_no", f6.ssn_no);
        putBool(f, "addressRadio", f6.us_address);
        putBool(f, "incomeUsRadio", f6.givin_instruct);
      }

      const g7 = app.section_g7;
      if (g7) {
        const f = this.form.personal7;
        put(f, "account_one", g7.shares_acc);
        put(f, "shares_amount", g7.shares_amt);
        put(f, "account_two", g7.spshares_ac);
        put(f, "special_shares_amount", g7.spshares_amt);
        put(f, "account_three", g7.deposit_ac);
        put(f, "deposit_ac_amount", g7.deposit_amt);
        put(f, "reg_fee_amount", g7.reg_fee);
        put(f, "total_amount", g7.total);
      }

      const h8 = app.section_h8;
      if (h8) {
        const f = this.form.personal8;
        const n1 = h8.nominee_1;
        if (n1) {
          put(f, "appointnominee_name1", n1.name);
          put(f, "appointnominee_email1", n1.email_address);
          put(f, "appointnominee_pno1", n1.contact);
          put(f, "appointnominee_pno1code", n1.ext_contact);
          put(f, "appointnominee_rel1", n1.relation);
          put(f, "appointnominee_otherel", n1.other_relative);
          put(f, "appointnominee_address1", n1.address);
          put(f, "appointnominee_dob1", n1.applicant_dob);
        }
        const n2 = h8.nominee_2;
        if (n2) {
          put(f, "appointnominee_name2", n2.name);
          put(f, "appointnominee_email2", n2.email_address);
          put(f, "appointnominee_pno2", n2.contact);
          put(f, "appointnominee_pno2code", n2.ext_contact);
          put(f, "appointnominee_rel2", n2.relation);
          put(f, "appointnominee_othere2", n2.other_relative);
          put(f, "appointnominee_address2", n2.address);
          put(f, "appointnominee_dob2", n2.applicant_dob);
        }
        const n3 = h8.nominee_minor;
        if (n3) {
          put(f, "trusteeRadioo", n3.caretaker && n3.caretaker.type);
          put(f, "appointnominee_name3", n3.name);
          put(f, "appointnominee_email3", n3.email_address);
          put(f, "appointnominee_pno3", n3.contact);
          put(f, "appointnominee_pno3code", n3.ext_contact);
          put(f, "relationbenifit3", n3.relation);
          put(f, "appointnominee_othere3", n3.other_relative);
          put(f, "appointnominee_address3", n3.address);
          put(f, "appointnominee_dob3", n3.applicant_dob);
        }
      }

      this.form.personal9.appliname = `${this.form.personal1.firstName || ""} ${
        this.form.personal1.surname || ""
      }`.trim();
      this.loadExistingDocs(app.section_a1);
    },
    // The wizard only marks the opening tab as done; colour every earlier step too.
    markStepsDone(upTo) {
      this.$nextTick(() => {
        const wizard = this.$refs.wizard;
        if (!wizard || !Array.isArray(wizard.tabs)) return;
        wizard.tabs.forEach((tab, index) => {
          if (index <= Number(upTo)) tab.checked = true;
        });
      });
    },
    // The step to open = the first one that has not been saved yet (progress is
    // derived from what is stored, so it is the same after any number of refreshes).
    computeStartIndex(app) {
      const steps =
        this.radioSelected1 === "adult"
          ? ["section_a1", "section_b2", "section_c3", "section_e5", "section_f6", "section_h8", "section_i9"]
          : ["section_a1", "section_b2", "section_c3", "section_d4", "section_e5", "section_f6", "section_h8", "section_i9"];
      let index = 0;
      while (index < steps.length - 1 && app && app[steps[index]]) index++;
      return index;
    },
    // ---- uploaded documents: name + Remove instead of the file input
    docName(slot) {
      const picked = this[DOC_FILE_KEYS[slot]];
      if (picked && picked.name) return picked.name;
      const saved = this.existingDocs[slot];
      return saved ? saved.name : "";
    },
    paySlipItems() {
      const saved = (this.existingDocs.pay_slip || []).map((slip) => ({
        key: `saved-${slip.id}`,
        name: slip.name,
        existing: true,
        id: slip.id,
      }));
      const pending = (this.selectedFile9 || []).map((file, index) => ({
        key: `new-${index}-${file.name}`,
        name: file.name,
        existing: false,
        index,
      }));
      return [...saved, ...pending];
    },
    loadExistingDocs(sectionA1) {
      const docs = { pay_slip: [] };
      if (sectionA1) {
        Object.keys(DOC_FILE_KEYS).forEach((slot) => {
          const row = sectionA1[slot];
          if (row && row.upload_doc) {
            docs[slot] = { name: row.upload_doc_name || "Uploaded document" };
          }
        });
        docs.pay_slip = (sectionA1.pay_slip || [])
          .filter((slip) => slip && slip.upload_doc)
          .map((slip) => ({
            id: slip.id,
            name: slip.upload_doc_name || "Uploaded document",
          }));
      }
      this.existingDocs = docs;
    },
    // after the personal step is saved the server copy is the single source of truth
    afterPersonalSaved(response) {
      Object.values(DOC_FILE_KEYS).forEach((key) => {
        this[key] = null;
      });
      this.selectedFile9 = [];
      this.loadExistingDocs(response && response.data && response.data.section_a1);
    },
    async removeDoc(slot, item) {
      // a file that is only picked (not saved yet) is simply dropped
      if (slot === "pay_slip") {
        if (item && !item.existing) {
          this.selectedFile9 = (this.selectedFile9 || []).filter(
            (_, index) => index !== item.index,
          );
          return;
        }
      } else if (this[DOC_FILE_KEYS[slot]]) {
        this[DOC_FILE_KEYS[slot]] = null;
        return;
      }
      // a saved file is deleted on the server (file and reference)
      this.docBusy = true;
      try {
        await axios.post("/applications/remove_document/", {
          app_id: this.app_id,
          slot,
          slip_id: item ? item.id : undefined,
        });
        const docs = { ...this.existingDocs };
        if (slot === "pay_slip") {
          docs.pay_slip = (docs.pay_slip || []).filter(
            (slip) => slip.id !== item.id,
          );
        } else {
          delete docs[slot];
        }
        this.existingDocs = docs;
      } catch (error) {
        this.notifySaveError(error);
      } finally {
        this.docBusy = false;
      }
    },
    // ---- signature files (step 7): picked file name + Change / Remove
    signatureName(key) {
      const file = this[key];
      return file && file.name ? file.name : "";
    },
    removeSignature(key) {
      this[key] = null;
    },
    // ---- stepper: after a step is saved and the wizard moves on, bring the
    // stepper back into view so the next step starts from its top.
    onStepChanged() {
      const wizard = this.$refs.wizard;
      const expected = this.radioSelected1 === "adult" ? 7 : 8;
      // the wizard also emits while its tabs are still registering (resume on
      // a later step); only react once every tab exists
      if (!wizard || !Array.isArray(wizard.tabs) || wizard.tabs.length < expected) {
        return;
      }
      this.scrollToStepper();
    },
    scrollToStepper() {
      this.$nextTick(() => {
        const root = this.$refs.wizard && this.$refs.wizard.$el;
        const nav = root && root.querySelector(".wizard-navigation");
        let top = 0;
        if (nav) {
          const rect = nav.getBoundingClientRect();
          const navTop = rect.top + window.pageYOffset;
          // scrolling to the very top shows the stepper unless the page header
          // is tall enough to push it below the fold; then align it instead
          if (navTop + rect.height > window.innerHeight - 8) {
            const header = document.querySelector("header");
            const pinned =
              header && /fixed|sticky/.test(window.getComputedStyle(header).position);
            top = Math.max(0, navTop - (pinned ? header.offsetHeight : 0) - 12);
          }
        }
        window.scrollTo({ top, behavior: "smooth" });
      });
    },
    onComplete() {
      this.$router.push("/?submit=yes");
    },
    resetFields() {
      this.showRadio = false;
    },
    validateFormTwo() {
      if (this.v$.form.personal2.$invalid) {
        this.v$.form.personal2.$touch();
        if (this.form.personal2.employStatus === "unemployed") {
          if (
            !this.form.personal2.user_employer &&
            !this.form.personal2.user_w_phone_no &&
            this.form.personal2.user_occupation
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    validateFormThree() {
      if (this.v$.form.personal3.$invalid) {
        this.v$.form.personal3.$touch();
        return false;
      } else {
        return true;
      }
    },
    validateFormFive() {
      if (this.v$.form.personal5.$invalid) {
        this.v$.form.personal5.$touch();
        return false;
      } else {
        return true;
      }
    },
    validateFormsix() {
      if (this.v$.form.personal6.$invalid) {
        this.v$.form.personal6.$touch();
        if (
          this.form.personal6.ssn_no === "" &&
          this.form.personal6.tobagoRadio &&
          this.form.personal6.citizenRadio &&
          this.form.personal6.addressRadio &&
          this.form.personal6.incomeUsRadio
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    validateFormSeven() {
      if (this.v$.form.personal7.$invalid) {
        this.v$.form.personal7.$touch();
        return false;
      } else {
        return true;
      }
    },
    validateFormEight() {
      if (this.v$.form.personal8.$invalid) {
        this.v$.form.personal8.$touch();
        return false;
      } else {
        return true;
      }
    },
    validateFormNine() {
      if (this.v$.form.personal9.$invalid) {
        this.v$.form.personal9.$touch();
        return false;
      } else {
        return true;
      }
    },
    selectResidency(value) {
      this.residencyType = value;
      this.residencyError = false;
    },
    notifySaveError(error) {
      const response = error && error.response;
      const data = response && response.data;
      let text =
        data && typeof (data.error || data.detail || data.msg) === "string"
          ? data.error || data.detail || data.msg
          : "We could not save this step. Please check your details and try again.";
      if (response && (response.status === 404 || response.status === 410)) {
        text =
          "Your application has expired or could not be found. Please start a new application.";
        setTimeout(() => this.$router.push("/"), 3000);
      }
      this.saveErrorText = text;
      window.scrollTo({ top: 0, behavior: "smooth" });
      clearTimeout(this.saveErrorTimer);
      this.saveErrorTimer = setTimeout(() => {
        this.saveErrorText = "";
      }, 8000);
    },
    submitDataInitial() {
      // Both choices are required before the user can move on.
      this.residencyError = !this.residencyType;
      this.radioError = !this.radioSelected1;
      if (this.residencyError || this.radioError) {
        return;
      }
      var adult = "";
      // Make the API request with the entered email
      var t = storageService.getItem("accessToken");
      if (this.radioSelected1 === "adult") {
        adult = true;
      } else {
        adult = false;
      }
      axios
        .post("/applications/initial_application_submit/", {
          token: t,
          is_adult: adult,
          residency_type: this.residencyType,
          is_fatca: this.checkFeildInput2,
          is_pep: this.checkFeildInput1,
          risk_cat: this.riskInput,
        })
        .then((response) => {
          // Handle the response
          this.app_id = response.data.id;
          this.$refs.anotherButton.click();
          this.startIndex = 0;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
          this.notifySaveError(error);
        });
    },
    submitDataEmployement() {
      // this is for Employment Information
      var t = storageService.getItem("accessToken");
      let r = false;
      return axios
        .post("/applications/employment_information_submit/", {
          token: t,
          app_id: this.app_id,
          emp_status: this.form.personal2.employStatus,
          pay_freq: this.form.personal2.frequencyStatus,
          avg_monthly_inc: this.form.personal2.averageIncm,
          occupation: this.form.personal2.user_occupation,
          employer: this.form.personal2.employer,
          employer_add: this.form.personal2.user_employer,
          work_phone: this.form.personal2.user_w_phone_no,
          work_phonecode: this.form.personal2.user_w_phone_nocode,
          ext: this.form.personal2.user_phone_no,
          school: this.form.personal2.user_isstudent,
          emp_period:
            this.form.personal2.user_howlong +
            " " +
            this.form.personal2.user_howlong2,
        })
        .then(() => {
          // Handle the response
          r = true;
          return r;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
          this.notifySaveError(error);
          throw error; // makes the tab change handler stay on this tab
        });
    },
    submitDataAccount() {
      // this is for Account Activity
      var t = storageService.getItem("accessToken");
      let r = false;
      return axios
        .post("/applications/account_activity_submit/", {
          token: t,
          app_id: this.app_id,
          how_account_funded: this.form.personal3.accFunded,
          member_any_credit_union: this.form.personal3.accountActi,
          member_any_credit_union_desc: this.form.personal3.accountActiDesc,
          other_details: this.form.personal3.other_details,
          no_of_transactions: this.form.personal3.numTrans,
          vol_of_transactions: this.form.personal3.volTrans,
          socuce_of_income: this.form.personal3.socuceofincome,
          area_of_details: this.form.personal3.areaofdetails,
        })
        .then(() => {
          // Handle the response
          r = true;
          return r;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
          this.notifySaveError(error);
          throw error; // makes the tab change handler stay on this tab
        });
    },
    submitDataPEP() {
      var t = storageService.getItem("accessToken");
      let r = false;
      return axios
        .post("/applications/politically_exposed_persons/", {
          token: t,
          app_id: this.app_id,
          prom_entrust: this.form.personal5.entrustedRadio,
          immd_famly: this.form.personal5.memberOfRadio,
          close_prsonl: this.form.personal5.referredRadio,
        })
        .then(() => {
          // Handle the response
          r = true;
          return r;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
          this.notifySaveError(error);
          throw error; // makes the tab change handler stay on this tab
        });
    },
    submitDataFATCA() {
      var t = storageService.getItem("accessToken");
      let r = false;
      return axios
        .post("/applications/foreign_account_tax/", {
          token: t,
          app_id: this.app_id,
          other_citizen: this.form.personal6.tobagoRadio,
          us_citizen: this.form.personal6.citizenRadio,
          ssn_no: this.form.personal6.ssn_no,
          us_address: this.form.personal6.addressRadio,
          givin_instruct: this.form.personal6.incomeUsRadio,
        })
        .then(() => {
          // Handle the response
          r = true;
          return r;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
          this.notifySaveError(error);
          throw error; // makes the tab change handler stay on this tab
        });
    },
    submitData_accountandfees() {
      //this is for Account/Fees
      var t = storageService.getItem("accessToken");
      let r = false;
      return axios
        .post("/applications/account_and_fees/", {
          token: t,
          app_id: this.app_id,

          account_number_one: this.form.personal7.account_one,
          account_number_two: this.form.personal7.account_two,
          account_number_three: this.form.personal7.account_three,
          shares_amount: this.form.personal7.shares_amount,
          special_shares_amount: this.form.personal7.special_shares_amount,
          deposit_ac_amount: this.form.personal7.deposit_ac_amount,
          reg_fee_amount: this.form.personal7.reg_fee_amount,
          total_amount: this.form.personal7.total_amount,
        })
        .then(() => {
          // Handle the response
          r = true;
          return r;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error sending email:", error);
          this.notifySaveError(error);
          throw error; // makes the tab change handler stay on this tab
        });
    },
    incSlab() {
      this.isLoading = true;
      axios
        .get("/applications/avg_inc_slab_new/")
        .then(() => {
          // Handle the response
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};